/**
****************************************************
***                        *******    ******    ****
***                        ******    ******    *****
***********       **************    ******    ******
***********       *************    ******    *******
***********       ************    ******    ********
***********       ***********    ******    *********
***********       **********    ******    **********
***********       *********    ******    ***********
***********       ********    ******    ************
***********       *******    ******    *************
***********       ******    ******    **************
****************************************************
* --------------------------------------------------
* Travlr UiKit: callbackHandler.js
* By Travlr Team
* --------------------------------------------------
*/

// const
const NAME = 'callbackHandler'

class CallbackHandler {
  constructor (config) {
    this._config = config
    this._callback = config.callback
    this._params = config.params

    this.init()
  }

  init () {
    if (this._callback && typeof this._callback === 'function') {
      this._callback(this._params)
    }
  }
}

export default CallbackHandler
